import { snakeCase } from 'lodash-es';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class TranslationKeyService {
  constructor(private translateService: TranslateService) {}

  generateTranslationKey(namespace: string, ...args: string[]): string {
    return [namespace, ...args].map(part => snakeCase(part).toUpperCase()).join('.');
  }

  translateInstant(namespace: string, ...args: string[]): string {
    return this.translateInstantParam(undefined, namespace, ...args);
  }

  translateInstantParam(params: object | undefined, namespace: string, ...args: string[]): string {
    return this.translateService.instant(this.generateTranslationKey(namespace, ...args), params);
  }
}
